import ComponentFactory from './ComponentFactory.js';
import Icons from './utils/Icons.js';

class Main {
  constructor() {
    this.loader = document.querySelector('.loader');
   
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');

    Icons.load();
    new ComponentFactory();



    this.refreshPage();
  }

  refreshPage() {
    window.addEventListener("load", () => {
      const hash = window.location.hash;
      if (!hash) return;

      // cancel browser’s default jump
      window.scrollTo(0, 0);

      const target = document.querySelector(hash);
      if (!target) return;

      // define the smooth scroll function
      const scrollToTarget = () => {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      };

      // 1️⃣ wait a bit for DOM and CSS transitions
      setTimeout(scrollToTarget, 200);

      // 2️⃣ in case GSAP or other animations modify layout later,
      // trigger another scroll once things settle
      setTimeout(scrollToTarget, 400);

      setTimeout(scrollToTarget, 1000);

      setTimeout(scrollToTarget, 2000);

      // 3️⃣ (optional) if you use GSAP ScrollTrigger:
      // gsap.delayedCall(2, scrollToTarget);
    });
  }

}

new Main();
